import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './benefit.module.less';
import cn from 'classnames';
import {Input} from '../../../../hola/pub/lib/input';
import {Button} from '../../../../hola/pub/lib/button';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

export interface i_benefits {
  icon: string;
  title: string;
  des: string;
  bg: string
}

const benefits = [
    {
        icon: 'https://cdn4.toolip.io/content/free_product.svg',
        title: 'Quick and Easy Setup',
        des: `Get started in minutes with user-friendly setup 
        guides and instant API access, making proxy integration a breeze.`,
        bg: '#D9EAFF'
    },
    {
        icon: 'https://cdn4.toolip.io/content/use_case.svg',
        title: 'Compatible with All Major Platforms',
        des: `From SEO tools to browsers, apps, and automation bots,
        our proxies work seamlessly with the platforms you rely on most.`,
        bg: '#E7E5FF'
    },
    {
        icon: 'https://cdn4.toolip.io/content/social.svg',
        title: 'High Performance for Intensive Tasks',
        des: `Experience reliable, high-speed connections
        for data scraping, managing accounts— all without interruptions.`,
        bg: '#F8EBF3'
    },
];

interface i_benefits_props {
  title?: string;
  hero_title_tag?: string;
}

interface i_benefits_editor_props {
  value: i_benefits_props;
  on_change: (v: i_benefits_props) => void;
  on_cancel: () => void;
}

export const Benefits_editor = (
    props: i_benefits_editor_props
)=>{
    const [state, set_state] = useState<i_benefits_props>(
        props.value || {});
    useEffect(()=>{
        set_state(props.value);
    }, [props.value]);

    return <div>
      <Input size={'sm'} label={'Title'} value={state.title || ''}
        on_change={v=>set_state({...state, title: v})}/>
      <Title_header_select value={state.hero_title_tag} on_select={v=>
        set_state({...state, hero_title_tag: v})}/>
      <Button caption={'Save'} size={'s'}
        on_click={()=>props.on_change(state)} />
      <Button caption={'Cancel'} size={'s'} on_click={()=>props.on_cancel()} />
    </div>;
};

const Benefit =({icon, title, des, bg}: i_benefits)=>
    <div className={styles.benefit_item} style={{backgroundColor: bg}}>
        <img src={icon} alt={icon} />
        <span>{title}</span>
        <p>{des}</p>
    </div>;

export const Benefits = (props: i_benefits_props)=>{
  const {theme} = useContext(Settings_context);
  return <div className={cn(theme.container, styles.benefit)}>
    <Dynamic_heading className={styles.benefit_title}
      tag={props.hero_title_tag} dangerouslySetInnerHTML={{
        __html: props.title || 'Get started effortlessly'
      }}/>
    <div className={styles.benefit_block}>
      {benefits.map(i=><Benefit
        key={i.bg} icon={i.icon} title={i.title} des={i.des} bg={i.bg}/>)}
    </div>
  </div>;
};
